import { Injectable } from '@angular/core';
import { CAMP_MANAGER_CONFIG, isCampManagerApproved, addCampManager, removeCampManager } from '../config/camp-manager.config';

@Injectable({
  providedIn: 'root',
})
export class CampManagerAccessService {
  constructor() {}

  /**
   * Check if an email address is approved for camp manager access
   * @param email - The email address to check
   * @returns boolean - True if email is approved, false otherwise
   */
  isCampManagerApproved(email: string): boolean {
    return isCampManagerApproved(email);
  }

  /**
   * Get the list of approved camp manager emails
   * @returns string[] - Array of approved email addresses
   */
  getApprovedManagers(): string[] {
    return [...CAMP_MANAGER_CONFIG.approvedManagerEmails];
  }

  /**
   * Add an email to the camp manager approved list
   * @param email - The email address to add
   */
  addCampManager(email: string): void {
    addCampManager(email);
  }

  /**
   * Remove an email from the camp manager approved list
   * @param email - The email address to remove
   */
  removeCampManager(email: string): void {
    removeCampManager(email);
  }
}
